import React, { useState, useRef } from "react";
import { message, Button, notification } from "antd";
import { ethers } from "ethers";

import "./MintPage.scss";

export default function MintPage(props) {
  const {
    address,
    writeContracts,
    onClickConnect,
    onClickDisconnect,
  } = props;

  const amountInput = useRef();
  const [amount, setAmount] = useState(1);
  
  async function mint() {
    const parsedAmount = parseFloat(amountInput.current.value);
    if(!parsedAmount) {
      setAmount(0);
      return;
    }

    const cost = ethers.utils.parseEther(amount.toString());
    try {
      const tx = await writeContracts.METH.deposit({ value: cost });
      tx.wait(1).then(receipt => {
        console.log(receipt)
        if(receipt && receipt.events) {
          for(let i = 0; i < receipt.events.length; i++) {
            const event = receipt.events[i];
            if(event.event === "Transfer") {
              message.success(
                <div>
                  <div>You wrapped {amount} ETH for {amount} METH!</div>
                </div>, 5
              );
              break;
            }
          }
        }
      });
    } catch(e) {
      let details = e && e.data && e.data.message ? e.data.message : null;
      if(!details) {
        details = e && e.message ? e.message : null;
      }
      notification.open({
        message: 'Error',
        description: <div>
          Something went wrong creating the transaction for you to sign :(
          {details && <p><br/>{details}</p>}
        </div>
      });
    }
  }

  function connect() {
    onClickConnect();
  }

  function disconnect() {
    onClickDisconnect();
  }

  return (
    <div className="MintPage">
      { !address &&
        <div>
          <p>Connect your wallet to mint METH.</p>
          <Button type="primary" shape="round" onClick={connect}>Connect</Button>
        </div>
      }
      { address &&
        <>
          <div className="minter">
            <span>How much METH would you like to mint?</span>
            <input
              ref={amountInput}
              type="number"
              min="1"
              max="120"
              value={amount}
              onChange={e => setAmount(e.target.value)}
            />
            <Button type="primary" shape="round" onClick={mint}>Mint</Button>
          </div>
          <Button style={{fontSize: 'smaller'}} type="default" shape="round" onClick={disconnect}>Disconnect</Button>
        </>
      }
    </div>
  );
};
